import { Injectable, computed, inject } from '@angular/core';
import type { CompanyUiModel } from '../types';
import { getInitials } from '../../shared/utils';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class CompanyFacade {
  private readonly tenant = inject(TenantService);

  readonly company = computed<CompanyUiModel | null>(() => {
    const activeCompany = this.tenant.activeCompany();
    const fallbackCompany = this.tenant.companies()[0] ?? null;
    const company = activeCompany ?? fallbackCompany;
    if (!company) return null;

    return {
      id: company.id,
      name: company.name,
      initials: getInitials(company.name, 'CO'),
      logoUrl: company.logoUrl ?? null,
    };
  });
}
